var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserQuestion = function SvgUserQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#B0C9E2",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M44 14.567c0 5.283-4.478 9.567-10 9.567q-.976 0-1.935-.18c-.459-.086-.688-.129-.849-.104-.16.024-.387.145-.841.387a6.5 6.5 0 0 1-4.224.656 5.3 5.3 0 0 0 1.087-2.348c.1-.53-.148-1.045-.52-1.422C25.034 19.412 24 17.105 24 14.567 24 9.284 28.478 5 34 5s10 4.284 10 9.567Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#B0C9E2",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M30.984 15h.017m5.983 0h.017"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#B0C9E2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M15.004 43H9.436c-.646 0-1.296-.09-1.89-.346-1.933-.83-2.914-1.927-3.37-2.614-.26-.39-.224-.887.059-1.262 2.24-2.975 7.442-4.772 10.778-4.772s8.53 1.797 10.77 4.772c.282.375.319.872.059 1.262-.457.687-1.438 1.783-3.371 2.614-.594.255-1.244.346-1.89.346zM20.572 23.578a5.55 5.55 0 0 1-5.557 5.545 5.55 5.55 0 0 1-5.558-5.545 5.55 5.55 0 0 1 5.557-5.546 5.55 5.55 0 0 1 5.558 5.546"
  })));
};
export default SvgUserQuestion;